<template>
  <div class="map" :id="initId">
    <div class="loction center">
      x：{{ mouseLng }}y：{{ mouseLat }}
    </div>
    <div class="time-step">
      <StepV ref="getTimeData" :timeResolutionUnit="timeResolutionUnit" :arrayList="AllCollection"
             :arrayIndex="layerIndex" :showSFM="true"/>
    </div>
    <div class="change-map" @mouseover="showMore=true" @mouseout="showMore=false">
      <div class="map-box" v-show="showMore">
        <p class="p1">{{ $t('cloudComputing.Chooseabasemap') }}</p>
        <hr>
        <div class="b-box centerS">
          <div class="base-site center2" @click="showWhere(i)" :class="i.isAc?'map-ac':'map-d-ac'" v-for="i in isEnglish?mapStyles_en:mapStyles" :key="i.index">
            <img :src="i.img" alt="">
            <p>{{i.name}}</p>
          </div>
        </div>
      </div>
      <div class="parent center">
        <img src="@/assets/image/earth.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import 'leaflet-draw'
import StepV from "@/components/Steps"
import axios from '@/utils/axios.min'

import 'leaflet-velocity/dist/leaflet-velocity.css'
import 'leaflet-velocity/dist/leaflet-velocity'
import {tiledMapLayer} from '@supermap/iclient-leaflet'

import DrawPlug from "@/utils/measure"

import {getImageShowList} from "@/api/product/index"

import {colorpicks} from "@/utils/common"
import {tiandituTileLayer} from '@supermap/iclient-leaflet';

export default {
  props: {
    productUnit: {
      type: String
    },
    timeResolutionUnit: {
      type: String
    },
    initId: {
      type: String,
      default: 'map'
    },
    timeRange: {
      type: Object
    },
    isplay: {
      type: Boolean
    },
    is2d: {
      type: Boolean
    },
    url: {
      type: String
    },
    collections: {
      type: Array
    },
    legendObj: {
      type: Object
    },
    simpleName: {
      type: String
    },
    coordinates: {
      type: String
    },
    dataSearchLatLng: {
      type: Object
    }
  },
  components: {
    StepV
  },
  data() {
    return {
      mapStyles:[
        {img: require('../../../assets/image/yx.png'),type:'yx', isAc: false,name:"影像",index:0},
        {img: require('../../../assets/image/sl.png'),type:'sl', isAc: true,name:"矢量",index:1},
      ],
      mapStyles_en:[
        {img: require('../../../assets/image/yx.png'),type:'yx', isAc: false,name:"image",index:0},
        {img: require('../../../assets/image/sl.png'),type:'sl', isAc: true,name:"vector",index:1},
      ],
      showMore: false,
      draw: null,
      baseMap: null,
      AllCollection: [],
      timer: null,
      startTime: '',
      endTime: '',
      largeZoomImage: null,
      lalayerIDlist: [],
      layerIndex: 0,
      isFirst: true,
      loading: false,
      showWind: false,
      initWind: false,
      measureGroup: null,
      mouseLat: 0,
      mouseLng: 0,
      imageLayer: null,
      markGroup: null,
      isEnglish: false,
    }
  },
  watch: {
    timeRange: {
      handler(ol, ne) {
        if (ol.start != ne.start || ol.end != ne.end) {
          this.AllCollection = []
          this.layerIndex = 0
          clearInterval(this.timer)
          this.imageLayer = null
          this.getLIST()
        }
      },
      deep: true
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    getMarker() {
      var myIcon = L.icon({
        iconUrl: require('../../../../src/assets/image/mark.png'),
        iconSize: [25, 35],
      });
      this.baseMap.on('mouseup', (e) => {
        let latlng = e.latlng;
        this.markGroup.clearLayers()
        L.marker([latlng.lat, latlng.lng], {icon: myIcon}).addTo(this.markGroup);
        this.$emit('searchHistoryData', latlng.lng, latlng.lat)
      });
    },
    initMark() {
      var myIcon = L.icon({
        iconUrl: require('../../../../src/assets/image/mark.png'),
        iconSize: [25, 35],
      });
      this.markGroup.clearLayers()
      L.marker([this.dataSearchLatLng.lat, this.dataSearchLatLng.lng], {icon: myIcon}).addTo(this.markGroup);
    },
    cancelMarker() {
      this.baseMap.off('mouseup')
      this.measureGroup.clearLayers()
      this.baseMap.off('mousedown');
      this.baseMap.off('mousemove');
      this.baseMap.off('dblclick');
    },
    renderLegend() {
      let c_list = this.legendObj.principalValue.split(',')
      let a = colorpicks(c_list, 100)
      var can = document.getElementById("legend");
      var cans = can.getContext('2d');
      //创建一个线性渐变对象
      var gnt1 = cans.createLinearGradient(0, 160, 0, 0);
      a.forEach((element, index) => {
        gnt1.addColorStop(index * (1 / a.length), element);
      });
      cans.fillStyle = gnt1;
      //绘制一个矩形
      cans.fillRect(0, 0, 240, 160);
    },
    ceju(unit) {
      let draw = new DrawPlug(this.baseMap, this.measureGroup, unit)
      draw.startDrawLine()
    },
    cemian() {
      let draw = new DrawPlug(this.baseMap, this.measureGroup)
      draw.startDrawPolygon()
    },
    newTimeAnimation() {
      let that = this
      this.timer = setInterval(() => {

        if (that.isplay) {
          return that.AllCollection[that.layerIndex].pngUrl
        }
        that.layerIndex++
        if (that.layerIndex === that.AllCollection.length - 1 || that.layerIndex > that.AllCollection.length - 1) {
          that.layerIndex = that.AllCollection.length - 1
          that.$emit('stopAnimate')
          that.layerIndex = 0
        }
        that.imageLayer.setUrl(that.AllCollection[that.layerIndex].pngUrl)
      }, 300)
    },
    showWhere(val) {
      this.mapStyles.forEach(element => {
        element.isAc = false
      });
      this.mapStyles_en.forEach(element => {
        element.isAc = false
      });
      val.isAc = true
      this.isFirst = true
      switch (val.index) {
        case 0:
          this.initImageMap()
          break;
      
        default:
          this.initMap()
          break;
      }
    },
    /**
     * @description: 初始化影像底图
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-03 10:39:11
     * @return {*}
     */
    initImageMap() {
      if (this.baseMap) {
        this.baseMap.remove()
      }
      let that = this
      const crsBaseMap = this.collections[0].baseUnderUrl
      var url
      if (crsBaseMap === '3995') {
        this.baseMap = L.map(this.initId, {
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-45888490.52, -47298112.34], [45888490.52, 45888490.52]),
            origin: L.point(-45888490.52, 45888490.52)
          }),
          center: [733210.56, -1230428.86],
          maxZoom: 18,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = this.iserverHeader+'/iserver/services/map-ImageBaseMap/rest/maps/BG4326_3995'
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '3413') {
        this.baseMap = L.map(this.initId, {
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-45751178.11, -45751178.11], [45751178.11, 45751178.11]),
            origin: L.point(-45751178.11, 45751178.11)
          }),
          center: [0, 0],
          maxZoom: 18,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = this.iserverHeader+'/iserver/services/map-ImageBaseMap/rest/maps/BG4326_3413'
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '4326') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.EPSG4326,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        tiandituTileLayer({
          layerType: 'img',
          key: '73ae12883e85f0abe62f8941835a4129'
        }).addTo(this.baseMap);
        if (!this.isEnglish) {
          tiandituTileLayer({
            layerType: 'img',
            isLabel: true,
            key: '73ae12883e85f0abe62f8941835a4129',
            noWrap: false,
          }).addTo(this.baseMap);
        }else{
          tiandituTileLayer({
            url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
            layerType: 'img',
            isLabel: true,
            key: '73ae12883e85f0abe62f8941835a4129',
            noWrap: false,
          }).addTo(this.baseMap);
        }
      } else if (crsBaseMap === '6931') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-12304634.27, -12304634.27], [12304634.27, 12304634.27]),
            origin: L.point(-12304634.27, 12304634.27)
          }),
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = this.iserverHeader+'/iserver/services/map-ImageBaseMap/rest/maps/BG4326_6931'
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '3031') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-196813683.09, -100120990.38], [160561879.38, 191038276.28]),
            origin: L.point(-196813683.09, 160561879.38)
          }),
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = this.iserverHeader+'/iserver/services/map-ImageBaseMap/rest/maps/BG4326_3031'
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      }
      this.measureGroup = L.layerGroup().addTo(this.baseMap);
      this.markGroup = L.layerGroup().addTo(this.baseMap);
      this.baseMap.on('mousemove', function (e) {
        that.mouseLat = e.latlng.lat.toFixed(6)
        that.mouseLng = e.latlng.lng.toFixed(6)
      })

      try {
        this.getLIST()
        this.initMark()
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 初始化矢量底图
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-03 10:39:24
     * @return {*}
     */
    initMap() {
      if (this.baseMap) {
        this.baseMap.remove()
      }
      let that = this
      const crsBaseMap = this.collections[0].baseUnderUrl
      let url
      if (crsBaseMap === '3995') {
        this.baseMap = L.map(this.initId, {
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-45888490.52, -47298112.34], [45888490.52, 45888490.52]),
            origin: L.point(-45888490.52, 45888490.52)
          }),
          center: [733210.56, -1230428.86],
          maxZoom: 18,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = initmapUlr + this.collections[0].underPaintingUrl
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '3413') {
        this.baseMap = L.map(this.initId, {
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-45751178.11, -45751178.11], [45751178.11, 45751178.11]),
            origin: L.point(-45751178.11, 45751178.11)
          }),
          center: [0, 0],
          maxZoom: 18,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = initmapUlr + this.collections[0].underPaintingUrl
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '4326') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.EPSG4326,
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        tiandituTileLayer({
          layerType: 'vec',
          key: '73ae12883e85f0abe62f8941835a4129'
        }).addTo(this.baseMap);
        if (!this.isEnglish) {
          tiandituTileLayer({
            layerType: 'vec',
            isLabel: true,
            key: '73ae12883e85f0abe62f8941835a4129',
            noWrap: false,
          }).addTo(this.baseMap);
        }else{
          tiandituTileLayer({
            url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
            layerType: 'img',
            isLabel: true,
            key: '73ae12883e85f0abe62f8941835a4129',
            noWrap: false,
          }).addTo(this.baseMap);
        }
      } else if (crsBaseMap === '6931') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-12304634.27, -12304634.27], [12304634.27, 12304634.27]),
            origin: L.point(-12304634.27, 12304634.27)
          }),
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = initmapUlr + this.collections[0].underPaintingUrl
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      } else if (crsBaseMap === '3031') {
        this.baseMap = L.map(this.initId, {
          center: [0, 0],
          maxZoom: 18,
          crs: L.CRS.NonEarthCRS({
            bounds: L.bounds([-196813683.09, -100120990.38], [160561879.38, 191038276.28]),
            origin: L.point(-196813683.09, 160561879.38)
          }),
          zoomControl: false,
          attributionControl: false,
          zoom: 1,
        });
        url = initmapUlr + this.collections[0].underPaintingUrl
        tiledMapLayer(url, {
          noWrap: true
        }).addTo(this.baseMap);
      }
      // this.baseMap.on("zoom",function(){
      //     //8级别换影像
      //     const zoomLevel = that.baseMap.getZoom()
      //     if(zoomLevel>7){
      //         that.imageLayer.setOpacity(0)
      //     }else{
      //         that.imageLayer.setOpacity(1)
      //     }
      // })
      this.measureGroup = L.layerGroup().addTo(this.baseMap);
      this.markGroup = L.layerGroup().addTo(this.baseMap);
      this.baseMap.on('mousemove', function (e) {
        that.mouseLat = e.latlng.lat.toFixed(6)
        that.mouseLng = e.latlng.lng.toFixed(6)
      })

      try {
        this.getLIST()
        this.initMark()
        // this.addOneImage()
      } catch (error) {
        console.log(error);
      }
    },
    getLIST() {
      let that = this
      this.loading = true
      const startTime = that.timeRange.start + ' 00:00:00'
      const endTime = that.timeRange.end + ' 23:59:59'

      let param = {
        productId: that.simpleName,
        startTime: startTime,
        endTime: endTime
      }
      getImageShowList(param).then(res => {
        that.AllCollection = res.data
        // 1230
        let bounds = JSON.parse(that.coordinates)

        const crsBaseMap = this.collections[0].baseUnderUrl
        let imageBounds
        if (crsBaseMap === '3995') {
          imageBounds = [[bounds[0], bounds[1]], [bounds[2], bounds[3]]]
        } else {
          imageBounds = [[bounds[1], bounds[2]], [bounds[3], bounds[0]]]
        }
        const imageUrl = res.data[that.layerIndex].pngUrl
        that.imageLayer = L.imageOverlay(imageUrl, imageBounds)
        that.baseMap.addLayer(that.imageLayer)
        if (that.isFirst) {
          that.baseMap.fitBounds(that.imageLayer.getBounds())
          that.isFirst = false
        }
        that.newTimeAnimation()
      })
    },

    addOneImage() {
      let that = this
      const collectionNames = []
      this.collections.forEach(item => {
        collectionNames.push(item.resourceName)
      })
      const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=SMID=1'
      axios.get(url).then(res => {
        res.data.features.forEach(feature => {
          that.AllCollection.push({
            collection: feature.collection,
            name: feature.assets.data.title,
            time: feature.properties.createtime
          })
        })
        const rootUrl = this.iserverLayerHeader + that.url
        that.largeZoomImage = L.supermap.imageTileLayer(rootUrl, {
          noWrap: true,
          subdomains: ["8091"],
          collectionId: that.AllCollection[0].collection,
          names: [that.AllCollection[0].name]
        })
        // that.largeZoomImage.setOpacity(0)
        that.baseMap.addLayer(that.largeZoomImage)
      })
    },
  },

  created() {

  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
    this.initMap()
    // this.initImageMap()
  }
}
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;

  .loction {
    position: absolute;
    left: 12px;
    top: 0px;
    z-index: 100000;
    color: white;
    height: 29px;
    padding: 0 12px;
    background-image: url("../../../assets/image/product-detail-dialog/矩形 3 拷贝.png");
    background-size: 100% 100%;
  }

  .legend-my {
    position: absolute;
    left: 0;
    bottom: 0px;
    padding-left: 12px;
    z-index: 100000;

    .unit {
      color: white;
    }

    .right {
      position: absolute;
      left: 36px;
      bottom: 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 160px;

      p {
        width: 47px;
        display: inline;
        color: white;
      }
    }

    .legend-show {
      width: 24px;
      height: 160px;
    }
  }

  // .time-step{
  //     position: absolute;
  //     left: 211px;
  //     bottom: 10px;
  //     z-index: 1000;
  // }
}

/deep/ .iclient-leaflet-logo {
  display: none;
}

.change-map{
  position: absolute;
  right: 8px;
  // transform: translate(calc(50% + 200px), -20px);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  .parent{
    width: 46px;
    height: 46px;
    border-radius: 5px;
    background-color: white;
     cursor: pointer;
     margin-left: 12px;
  }
  .map-box{
    width: 206px;
    height: 130px;
    background: #FFFFFF;
    border-radius: 10px;
    .p1{
      color: black;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
    }
    hr{
      margin: 4px 0;
      width: 206px;
    }
  }
  .b-box{
    font-size: 12px;
    padding: 0 8px;
    .base-site{
      cursor: pointer;
    }
    img{
      width: 80px;
      height: 60px;
      border-radius: 4px;
    }
    .map-ac{
      img{
        border: 4px solid #3390F8;
      }
      color: #3390F8;
    }
    .map-d-ac{
      img{
        border: 4px solid white;
      }
      color: black;
    }
  }
}
</style>
